export enum Role {
    ADMIN_ALL = 'ADMIN_ALL',
    ADMIN_EIG = 'ADMIN_EIG',
    ADMIN_BLU = 'ADMIN_BLU',
    ADMIN_FCS = 'ADMIN_FCS',
    ADMIN_EIG_ASIC = 'ADMIN_EIG_ASIC',
}
